module.exports = __webpack_public_path__ + "static/img/irole.996872b.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/mz/irole.png
// module id = jjjX
// module chunks = 7